export default __webpack_public_path__ + "5e073b5363794e8a4145e97cfad3b80e.svg";